import React from "react"
import sentryOptions from "utilities/sentry/sentry"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import AppProviders from "app/AppProviders"
import reportWebVitals from "reportWebVitals"
import ChunkLoadErrorBoundary from "components/ChunkLoadErrorBoundary/ChunkLoadErrorBoundary"

const container = document.getElementById("root")
const root = createRoot(container, sentryOptions)

root.render(
  // <React.StrictMode>
  <ChunkLoadErrorBoundary>
    <BrowserRouter>
      <AppProviders />
    </BrowserRouter>
  </ChunkLoadErrorBoundary>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
